export function roundToNearestThree(num) {
  const mod3 = num - (Math.floor(num / 3) * 3);
  return num + (mod3 ? 3 - mod3 : 0);
}



// WEBPACK FOOTER //
// ./src/utils/Channels.js